import { useCallback, useEffect, useState } from "react";

const useInfiniteScroll = (ref) => {
  const [entry, setEntry] = useState(0);
  const callback = useCallback(
    (entries) => {
      const [_entry] = entries;
      setEntry(_entry);
    },
    [entry]
  );
  useEffect(() => {
    const observer = new IntersectionObserver((e) => callback(e), {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    });
    if (ref?.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref?.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);
  return [entry];
};

export default useInfiniteScroll;
